import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import synchronize from './submodules/synchronize';
import store from '@/stores/store';


const state = {
    // No additional state needed beyond the synchronize module
};

const mutations = {
    // No additional mutations needed
};

const actions = {
    init({ commit, dispatch, state }, params) {
        dispatch("synchronize/init");
    },
};

export default {
    namespaced: true,
    state,

    actions,
    mutations,
    modules: {
        synchronize: synchronize(),
    }
};

